import { render } from "./willAddMoney.vue?vue&type=template&id=7fbf807c"
import script from "./willAddMoney.vue?vue&type=script&lang=js"
export * from "./willAddMoney.vue?vue&type=script&lang=js"

import "./willAddMoney.vue?vue&type=style&index=0&id=7fbf807c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__